import { jsx as c } from "react/jsx-runtime";
const r = (l) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...l,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        d: "M13.047 9.242c-.376-2.493-3.573-5.79-3.573-5.79l-.796.86L7.933 1.5s-4.527 4.756-5 7.922c-.34 2.272.982 5.077 4.999 5.078 4.713 0 5.452-3.026 5.115-5.258ZM6.99 12.677c-.416-.272-.473-.572-.473-.83 0-.393.368-.998.983-1.619.146-.147.293-.283.433-.405.129.113.264.237.399.372.636.634 1.016 1.252 1.016 1.652 0 .258-.056.557-.472.83-.376.246-.823.322-.943.322-.121 0-.568-.076-.943-.322Zm4.563-1.801c-.087.447-.26.824-.514 1.12a2.104 2.104 0 0 1-.214.213c.016-.115.024-.236.024-.361 0-2.021-2.916-3.916-2.916-3.916s-2.915 1.894-2.915 3.915l.001.087c-.503-.59-.729-1.444-.602-2.29.153-1.029.997-2.607 2.374-4.445.143-.19.285-.375.424-.551l.013.048.699 2.636L9.44 5.696c.16.198.328.413.497.641.934 1.259 1.512 2.371 1.627 3.13.075.497.07.985-.012 1.41v-.001Z"
      }
    )
  }
);
export {
  r as Gas
};
